import img1 from '../images/items/bano.jpg'
import img2 from '../images/items/desayuno.jpg'
import img3 from '../images/items/cochera.jpg'
import img4 from '../images/items/cw.jpg'
import img5 from '../images/items/pileta.jpg'

const dataServicesHighlight = [
    {
        img: img1,
        text: 'Contamos con un vestuario de uso exclusivo para mujeres, diseñado para brindar comodidad, privacidad y tranquilidad durante toda tu estadía.',
        name: 'Vestuario Exclusivo para Mujeres',
    },
    {
        img: img2,
        text: 'Empezá el día con toda la energía. Ofrecemos un desayuno buffet completo y variado, perfecto para planificar tu próxima aventura.',
        name: 'Desayuno Buffet',
    },
    {
        img: img3,
        text: 'Olvídate de buscar dónde estacionar. Contamos con cochera propia para que tu vehículo esté seguro y siempre a tu disposición.',
        name: 'Cochera Propia',
    },
    {
        img: img4,
        text: 'Trabaja con total comodidad y la mejor conexión a internet. Nuestro espacio de Cowork está diseñado para que seas productivo sin salir del hostel.',
        name: 'Espacio Cowork',
    },
    {
        img: img5,
        text: 'Disfruta de nuestra pileta al aire libre. Ideal para relajarte después de un día recorriendo la ciudad, tomar sol y compartir con otros viajeros.',
        name: 'Pileta',
    },
]

export default dataServicesHighlight;
